export const APP_NAME = process.env.REACT_APP_NAME;
export const API_URL = process.env.REACT_APP_API;
export const IMAGE_URL =
  "https://edotco-bucket-dev.s3.ap-southeast-1.amazonaws.com/";
// export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
export const AUTH_SAVE = process.env.REACT_APP_AUTH_SAVE_NAME;
export const MAP_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
